import { createPermission } from '@backstage/plugin-permission-common';

export const parkingLotManagerDeletePermission = createPermission({
  name: 'parking-lot-manager.delete',
  attributes: { action: 'delete' },
});

export const activateSchedulerPermissions = createPermission({
  name: 'scheduler.activate.create',
  attributes: { action: 'create' },
});

export const runMaintenanceTaskPermissions = createPermission({
  name: 'scheduler.maintenance-task.create',
  attributes: { action: 'create' },

});

export const readMonitorScheduler = createPermission({
  name: 'scheduler.monitor.read',
  attributes: { action: 'read' },

});

// OpenControl permissions
export const openControlReadPermission = createPermission({
  name: 'supply-features.open-control.read',
  attributes: { action: 'read' },
});

export const openControlWritePermission = createPermission({
  name: 'supply-features.open-control.write',
  attributes: { action: 'create' },
});

export const openControlAdminPermission = createPermission({
  name: 'supply-features.open-control.admin',
  attributes: { action: 'update' },
});

export const openControlReprocessPermission = createPermission({
  name: 'supply-features.open-control.reprocess',
  attributes: { action: 'update' },
});

export const supplyFeaturesPermissions = [
  activateSchedulerPermissions,
  runMaintenanceTaskPermissions,
  readMonitorScheduler,
  openControlReadPermission,
  openControlWritePermission,
  openControlAdminPermission,
  openControlReprocessPermission,
];
